import { render, staticRenderFns } from "./TablePromo.vue?vue&type=template&id=24b84a7e"
import script from "./TablePromo.vue?vue&type=script&lang=js"
export * from "./TablePromo.vue?vue&type=script&lang=js"
import style0 from "./TablePromo.vue?vue&type=style&index=0&id=24b84a7e&prod&lang=css"
import style1 from "./TablePromo.vue?vue&type=style&index=1&id=24b84a7e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports